import * as React from "react";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { GrFormView } from "react-icons/gr";
import { Divider, Input, Modal, Table } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import debounce from "lodash/debounce";
import "../../../assets/css/style.css";
import { render } from "@testing-library/react";
import { ErrorToast, InfoToast, SuccessToast } from "../../ToastComponent";

const AddBusinessPd = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ProfileId = queryParams.get("ProfileId");
  const BusinessPdProfileId = queryParams.get("BusinessPdProfileId");
  const BranchId = queryParams.get("BranchId");
  const CustomerId = queryParams.get("CustomerId");

  console.log(ProfileId, BusinessPdProfileId, BranchId, CustomerId);

  const [branches, setBranches] = React.useState([]);
  const [profiles, setProfiles] = React.useState([]);
  const [customers, setCustomers] = React.useState([]);
  const [allBusinessPd, setAllBusinessPd] = React.useState([]);
  const [imageSelected, setImageSelected] = React.useState(null);
  const [customerNames, setCustomerNames] = React.useState([]);
  const [CustomerData, setCustomerData] = React.useState({});
  const [query, setQuery] = React.useState("");
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [buttonDisable, setButtonDisable] = React.useState(false);
  const [isConfirmModal, setIsConfirmModal] = React.useState(false);
  const [profileMismatchDetail, setProfileMismatchDetail] = React.useState([]);
  const [buisnessPdData, setBusinessPdData] = React.useState({
    id: 0,
    remark: "",
    status: 12,
    deviationRemarks: "",
    latitude: "",
    longitude: "",
  });

  // console.log("jiuy",CustomerData.profileMismatchedRemarks.length)

  React.useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setBusinessPdData({
          ...buisnessPdData,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
          deviationRemarks: CustomerData?.profileMismatchedRemarks,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const navigate = useNavigate();

  // console.log("cutomer", CustomerData.name);

  /** Table columns configuration */
  const columns = [
    {
      title: "Customer Name",
      dataIndex: "Name",
      render: (text, record) => (
        <span>
          {CustomerData.name} ({CustomerData?.applicationNo})
        </span>
      ),
    },
    {
      title: "Branch Name",
      dataIndex: "branch",
      render: (text, record) => <span>{CustomerData.branchName}</span>,
    },
    {
      title: "Profile Name",
      dataIndex: "name",
    },
    {
      title: "Mobile Number",
      dataIndex: "customerMobile",
      render: (text, record) => <span>{CustomerData.mobile}</span>,
    },
    {
      title: "Login Date",
      dataIndex: "created",
      render: (text, record) => <span>{CustomerData.created}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => <span>{CustomerData.status}</span>,
    },
    // {
    //   title: "View",
    //   render: () => <GrFormView cursor={"pointer"} size={30} />,
    // },
  ];

  const [businessPDData, setBusinessPDData] = React.useState({
    branchId: BranchId,
    customerId: CustomerId,
    profileId: imageSelected ? imageSelected?.id : null,
    latitude: "",
    longitude: "",
    SelfieUrl: null,
    ApplicationNo: "",
  });

  const [lastName, setLastName] = React.useState("");
  React.useEffect(() => {
    if (businessPDData.customerId == CustomerId) {
      setLastName(CustomerData.name);
    }
  }, [CustomerId]);

  console.log("first", CustomerData);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": { backgroundColor: "#ff9b44" },
    }),
  };

  const fetchBranchName = async () => {
    try {
      const { data } = await axios.get(
        Api_Url + "api/v1/Branch?PageNumber=1&PageSize=1000",
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setBranches(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProfiles = async () => {
    try {
      const { data } = await axios.get(
        Api_Url + "api/v1/BusinessProfile?PageNumber=1&PageSize=50",
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setProfiles(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllCustomer = async () => {
    const { data } = await axios.get(
      `${Api_Url}api/v1/Customer?PageNumber=1&PageSize=50`
    );
    setCustomers(data.data);
  };

  const fetchCustomerNames = React.useCallback(
    debounce(async (query) => {
      if (businessPDData.branchId) {
        try {
          const { data } = await axios.get(
            `${Api_Url}api/v1/Customer/bybranchidandname/${businessPDData.branchId}/${query}`
          );
          setCustomerNames(data.data);
        } catch (error) {
          console.log(error.response);
        }
      }
    }, 300),
    [businessPDData.branchId]
  );

  React.useEffect(() => {
    if (query && query.length > 2) {
      fetchCustomerNames(query);
    } else {
      setCustomerNames([]);
    }
  }, [query, fetchCustomerNames]);

  const handleCustomerChange = (event) => {
    setQuery(event.target.value);
    // if (businessPDData.customerId == CustomerId) {
    //   setQuery(CustomerData.name+ " " + (CustomerData.applicationNo))
    // }else{
    //   setQuery(event.target.value);
    // }
  };

  const handleSelectCustomer = (customer) => {
    setBusinessPDData((prev) => ({ ...prev, customerId: customer.id }));
    setQuery(`${customer.name} (${customer.applicationNo})`);
    setCustomerNames([]);
  };

  // console.log("mko",allBusinessPd.name)

  const handleSubmit = async () => {
    fetchCurentLocation();
    if (
      businessPDData.branchId === "" ||
      businessPDData.customerId === "" ||
      businessPDData.profileId === ""
    ) {
      return;
    }

    const formData = new FormData();
    formData.append("BranchId", businessPDData.branchId);
    formData.append("CustomerId", businessPDData.customerId);
    formData.append("ProfileId", businessPDData.profileId);
    formData.append("SelfieUrl", businessPDData.SelfieUrl);
    formData.append("ApplicationNo", businessPDData.ApplicationNo);
    formData.append("Latitude", businessPDData.latitude);
    formData.append("Longitude", businessPDData.longitude);

    const { data } = await axios.post(`${Api_Url}api/v1/BusinessPd`, formData, {
      headers: {
        Authorization: `Bearer ${
          JSON.parse(sessionStorage.getItem("user")).accessToken
        }`,
      },
    });
    console.log("allId", data.data);
    sessionStorage.setItem("businessPd", JSON.stringify(data.data));

    if (data.succeeded) {
      const navigateData = {
        BranchId: businessPDData.branchId,
        CustomerId: businessPDData.customerId,
        BusinessPdProfileId: data.data.businessPdProfileId,
        ProfileId: businessPDData.profileId,
      };
      navigate("view-profile", { state: navigateData });
    } else {
      console.log("API Failed");
      return;
    }
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setBusinessPDData((prev) => ({
          ...prev,
          latitude: latitude,
          longitude: longitude,
        }));
      });
    } else {
      return "Geolocation is not supported by this browser.";
    }
  };

  const fetchAllBusinessPDData = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/BusinessPd/getprofilesbycustomerid/${businessPDData.customerId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      if (response?.data?.succeeded) {
        setCustomerData(response?.data?.data);
        setProfileMismatchDetail(
          response?.data?.data?.profileMismatchedRemarks
        );
        console.log("all data", response?.data?.profiles);
        setAllBusinessPd(response?.data?.data?.profiles);
      }
    } catch (error) {
      ErrorToast(error?.response?.data?.message);
      setButtonDisable(true);
      console.log(error.response.data.message);
      setAllBusinessPd([]);
    }
  };

  React.useEffect(() => {
    fetchBranchName();
    fetchCustomerById(CustomerId);
    // setImageSelected(ProfileId);
    fetchProfiles();
    fetchAllCustomer();
    fetchCurentLocation();
  }, []);

  const fetchCustomerById = async (customerId) => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Customer/${customerId}`
      );
      console.log(response.data.data);
      handleSelectCustomer(response.data.data);
    } catch (error) {}
  };

  React.useEffect(() => {
    if (businessPDData.customerId) {
      fetchAllBusinessPDData();
    }
  }, [businessPDData.customerId]);

  React.useEffect(() => {
    if (imageSelected !== null) {
      setBusinessPDData((prev) => ({ ...prev, profileId: imageSelected?.id }));
    }
  }, [imageSelected]);

  const rowClassName = (text, record) => {
    return record.isProfileIncomeMismatched ? "table-row-red" : "";
  };
  // console.log("nmvmv", CustomerData.status);

  // Final Submit Button Process

  const hashCashFlow = CustomerData?.hasCashFlows;
  const hasAssest = CustomerData?.hasAssets;
  // const hasProfile = CustomerData?.hasProfiles;

  const handleFinalSubmit = async () => {
    const hasCashFlowMisMatch = CustomerData?.isCashFlowMismatched;
    const hasEachProfileIncomeMisMatch = CustomerData?.profileMismatchedRemarks;

    if (hashCashFlow == false) {
      InfoToast("Cashflow data is missing in this PD. Please fill it out first.")
      return;
    }
    if (hasAssest == false) {
      InfoToast("Assest data is missing in this PD. Please fill it out first.")
      return;
    }
    


    // if (hashCashFlow == false) {
    //   InfoToast(
    //     "Cashflow data is missing in this PD. Please fill it out first."
    //   );
    // } else if (hasAssest == false) {
    //   InfoToast("Assest is missing in this PD. Please fill it out first.");
    // }
     if (
      hasCashFlowMisMatch ||
      (hasEachProfileIncomeMisMatch && hasEachProfileIncomeMisMatch.length > 0)
    ) {
      setIsModalOpen(true);
      // ErrorToast("Pls Check the CashFlow and Assest Section firstly add this..")
    } else {
      setIsConfirmModal(true);
      // try {
      //   const data = {
      //     id: CustomerData.id,
      //     status: buisnessPdData.status,
      //     deviationRemarks: buisnessPdData.deviationRemarks,
      //     latitude: buisnessPdData.latitude,
      //     longitude: buisnessPdData.longitude,
      //   };
      //   const response = await axios.post(
      //     `${Api_Url}api/v1/BusinessPd/update-status/${CustomerData?.id}`,
      //     data
      //   );
      //   setIsConfirmModal(true);
      //   console.log("response", response);
      // } catch (error) {
      //   console.log("Add BuisnessPD Error", error);
      //   ErrorToast("Something went Wrong");
      // }
    }
  };

  // Reamrks Modal Submit

  const handleincomeModalSubmit = async () => {
    console.log(profileMismatchDetail);
    try {
      const data = {
        id: CustomerData.id,
        status: buisnessPdData.status,
        deviationRemarks: profileMismatchDetail,
        latitude: buisnessPdData.latitude,
        longitude: buisnessPdData.longitude,
        remark: buisnessPdData.remark,
      };
      const response = await axios.post(
        `${Api_Url}api/v1/BusinessPd/update-status/${CustomerData?.id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );

      console.log("response", response);
      if (response?.data?.succeeded) {
        SuccessToast("Data Updated Successfully");
        handleCancel();
        fetchAllBusinessPDData();
      }
    } catch (error) {
      ErrorToast(error?.response?.data?.message);
      handleCancel();
    }
  };

  // Confirmation Function

  const handleonfirmSubmitFunc = async () => {
    try {
      const result = {
        id: CustomerData.id,
        status: buisnessPdData.status,
        deviationRemarks: buisnessPdData.deviationRemarks,
        latitude: buisnessPdData.latitude,
        longitude: buisnessPdData.longitude,
      };
      const response = await axios.post(
        `${Api_Url}api/v1/BusinessPd/update-status/${CustomerData?.id}`,
        result,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response?.data?.succeeded) {
        SuccessToast(response?.data?.message);
        handleCancel();
      }
    } catch (error) {
      ErrorToast(error.response?.data?.message);
      handleCancel();
      // ErrorToast("something went wrong")
    }
  };

  const handleRemarkChange = (index, text) => {
    const updatedData = [...profileMismatchDetail];
    updatedData[index].remark = text;
    setProfileMismatchDetail(updatedData);
  };

  async function handleCancel() {
    setBusinessPdData({
      ...buisnessPdData,
      id: 0,
      remark: "",
      status: 12,
      deviationRemarks: "",
    });
    setIsModalOpen(false);
    setIsConfirmModal(false);
  }

  console.log("imageSelected", imageSelected);

  React.useEffect(() => {
    if (ProfileId) {
      const savedImage = profiles.find((image) => image.id == ProfileId);
      if (savedImage) {
        setImageSelected(savedImage);
      }
    }
  }, [profiles]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Container for Adding New Business PD */}
          <div className="col-lg-12 col-12 mx-auto mt-2 px-lg-2 px-0">
            <div className="rounded py-5 bg-white shadow">
              <h3 className="page-title text-center">Add Profile</h3>

              <div className="row mt-4 gap-3">
                {/* Branch Name Input */}
                <div className="col-12">
                  <div className="px-lg-5 px-2 w-100">
                    <select
                      className="custom-select-style"
                      value={businessPDData.branchId}
                      onChange={(event) =>
                        setBusinessPDData({
                          ...businessPDData,
                          branchId: parseInt(event.target.value),
                        })
                      }
                    >
                      <option value="null">Select Branch</option>
                      {branches.length > 0 &&
                        branches.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                {/* Customer Name Input */}
                <div className="col-12">
                  <div className="px-lg-5 px-2 w-100">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Select Customer"
                      value={query}
                      onChange={handleCustomerChange}
                    />
                    {customerNames.length > 0 && (
                      <ul className="list-group mt-2">
                        {customerNames.map((customer) => (
                          <li
                            key={customer.id}
                            className="list-group-item list-group-item-action"
                            onClick={() => handleSelectCustomer(customer)}
                          >
                            {customer.name} ({customer.applicationNo})
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                {/* Select Profile Container */}
                <div className="add-profile-container px-lg-4 px-3 mt-3">
                  <div className="row px-lg-1 px-1 row-gap-4">
                    {profiles.length > 0 &&
                      profiles.map((image) => (
                        <div
                          key={image.id}
                          className="col-lg-2 col-md-2 col-sm-3 col-4 d-flex flex-column align-items-center justify-content-start"
                          onClick={() =>
                            setImageSelected((prev) =>
                              prev === image ? null : image
                            )
                          }
                        >
                          <img
                            src={image?.webIconUrl}
                            className={`profile-img ${
                              imageSelected === image && "selected-image"
                            }`}
                            style={{ cursor: "pointer" }}
                            alt="Profile Image"
                          />
                          <p className="mb-0 text-center">{image?.name}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="d-flex justify-content-between px-lg-5 px-1 mt-4 ms-2">
                <div>
                  <button
                    className="btn btn-success submit-btn me-2"
                    disabled={buttonDisable}
                    onClick={() => {
                      navigate(`assestdetails/${CustomerData?.id}`, {
                        state: { CustomerData },
                      });
                    }}
                  >
                    Add Assest {hasAssest ? <i class="fa-solid fa-check-double"></i> : ""}
                  </button>

                  {/* {CustomerData && CustomerData?.hasCashFlows && (
                    <button
                    className="btn btn-success submit-btn"
                    disabled={buttonDisable}
                    onClick={() => {
                      navigate(`cashFlowdetails/${CustomerData?.id}`, {
                        state: { CustomerData },
                      });
                    }}
                  >
                    Add Cashflow
                  </button>
                  )} */}

                  <button
                    className="btn btn-success submit-btn"
                    disabled={buttonDisable}
                    onClick={() => {
                      navigate(`cashFlowdetails/${CustomerData?.id}`, {
                        state: { CustomerData },
                      });
                    }}
                  >
                    Add Cashflow {hashCashFlow ? <i class="fa-solid fa-check-double"></i> : ""}
                  </button>
                </div>

                <button
                  className="btn btn-primary submit-btn"
                  onClick={handleSubmit}
                  disabled={buttonDisable}
                >
                  Add Profile
                </button>
              </div>
            </div>
          </div>

          {/* Table Component */}
          <div className="col-12 px-4 mt-5">
            <Table
              className="table-striped"
              style={{ overflowX: "auto" }}
              columns={columns}
              dataSource={allBusinessPd}
              rowKey={(record) => record.id}
              rowClassName={rowClassName}
            />
          </div>
          <div className="d-flex justify-content-center align-items-center mt-5">
            <button
              className="btn btn-primary submit-btn"
              onClick={handleFinalSubmit}
              disabled={CustomerData?.status == "Submitted"}
            >
              Final Submit
            </button>
          </div>
        </div>

        {/* Add Remarks Modal */}

        <Modal
          title={
            <span className="d-flex fs-5 fw-bold text-danger justify-content-center">
              Income Mismatch Detected
            </span>
          }
          open={isModalOpen}
          onOk={() => setIsModalOpen(false)}
          onCancel={() => setIsModalOpen(false)}
          footer={[
            <div
              className="d-flex justify-content-between align-items-center"
              key="footer-buttons"
            >
              <button
                key="Cancel"
                className="btn btn-danger submit-btn"
                type="button"
                onClick={handleCancel}
              >
                Cancel
              </button>
              ,
              <button
                key="submit"
                className="btn btn-primary submit-btn"
                type="submit"
                onClick={handleincomeModalSubmit}
              >
                Submit
              </button>
            </div>,
          ]}
          width={600}
          mask={false}
          maskClosable={false}
          closeIcon={<span style={{ color: "red" }}>X</span>}
        >
          <div className="modal-body mt-3">
            <p>
              We have detected some income mismatch. Do you still want to
              submit?
            </p>
            <form>
              {CustomerData?.isCashFlowMismatched && (
                <div className="form-group mt-3">
                  <label htmlFor="cashFlowInput">Cash Flow</label>
                  <Input
                    id="cashFlowInput"
                    placeholder="Write a valid message, for income mismatch"
                    value={buisnessPdData.remark}
                    onChange={(e) =>
                      setBusinessPdData({
                        ...buisnessPdData,
                        remark: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              <Divider>Income Data</Divider>
              {profileMismatchDetail &&
                profileMismatchDetail.length > 0 &&
                profileMismatchDetail.map((item, index) => (
                  <div key={index} className="form-group mt-3">
                    <label className="income">{item.profileName}</label>
                    <Input
                      className="mt-2"
                      id={`incomeInput_${index}`}
                      placeholder="Enter Remark here"
                      value={item.remark}
                      onChange={(e) =>
                        handleRemarkChange(index, e.target.value)
                      }
                    />
                  </div>
                ))}
            </form>
          </div>
        </Modal>

        {/* Confirmation Modal */}

        <Modal
          title={
            <span className="fs-5 fw-bold text-success">Confirmation</span>
          }
          open={isConfirmModal}
          onOk={() => setIsConfirmModal(false)}
          onCancel={() => setIsConfirmModal(false)}
          footer={[
            <div className="d-flex justify-content-between align-items-center">
              <button
                key="Cancel"
                className="btn btn-danger submit-btn"
                type="button"
                onClick={handleCancel}
              >
                Cancel
              </button>
              ,
              <button
                key="submit"
                className="btn btn-primary submit-btn"
                type="submit"
                onClick={handleonfirmSubmitFunc}
              >
                Submit
              </button>
            </div>,
          ]}
          width={600}
          mask={false}
          maskClosable={false}
          closeIcon={<span style={{ color: "red" }}>X</span>}
        >
          <div className="modal-body mt-3">
            <h3>Are you sure you want to confirm To Final submit this form?</h3>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default AddBusinessPd;
